import getLogger from "js/core/logger";

const logger = getLogger();

// NOTE: we have to have the failsafe logic below because this code fails on
// some versions of Edge in PowerPoint on PC and we don't want this to block
// the sign in process


export function removeQueryParam(queryParamName: string) {
    try {
        if (window.history.pushState) {
            const url = new URL(window.location.href);
            url.searchParams.delete(queryParamName);
            window.history.pushState({ path: url.href }, "", url.href);
        }
    } catch (err) {
        logger.warn(`removeQueryParam() failed to remove query param ${queryParamName}, error: ${err.message}`);
    }
}

export function addQueryParam(queryParamName: string, value: string) {
    try {
        if (window.history.pushState) {
            const url = new URL(window.location.href);
            url.searchParams.set(queryParamName, value);
            window.history.pushState({ path: url.href }, "", url.href);
        }
    } catch (err) {
        logger.warn(`addQueryParam() failed to add query param ${queryParamName} with value ${value}, error: ${err.message}`);
    }
}
